<!-- BaseToggleSwitch.vue (admin) -->
<template tag="관리자 토글스위치 컴포넌트">
  <v-switch v-model="model" color="primary" hide-details></v-switch>
</template>

<script setup lang="ts">
import { defineModel } from "vue";

/* ------------------------------------------------------------
                          Model
   ------------------------------------------------------------ */
const model = defineModel<boolean>({ default: false });
</script>
